import React, { Fragment, useState } from 'react';
import ReactPlayer from 'react-player'

import FileIcon from 'components/FileIcon';

import extensions from 'constants/extensions';
import { set } from 'immutable';
import Spinner from '@atlaskit/spinner';
import ErrorIcon from '@atlaskit/icon/glyph/error';


const isImage = (ext) => extensions.image.includes(ext)

const isVideo = (ext) => extensions.video.includes(ext)

const renderImage = (url, loading, error, onLoad, onError) => {

    return (
        <Fragment>
            <img
                className='file-preview__preview__image'
                src={url}
                onLoad={onLoad}
                onError={onError}
            />
            {loading &&
                <div
                    className='file-preview__preview__loader file-preview__preview__loader--absolute'
                >
                    <Spinner />
                </div>
            }
            {/* {error &&
                <div
                    className='file-preview__preview__image file-preview__preview__image__loader'
                >
                    <h3>
                        <ErrorIcon />
                    </h3>
                </div> */}
        </Fragment>
    )
}

const renderVideo = (url, playing, onClickVideo, loading, error, onLoad, onError) => (
    <div className='file-preview__preview__video' onClick={onClickVideo}>
        <ReactPlayer
            onError={onError}
            onReady={onLoad}
            playing={playing}
            url={url}
            width='100%'
        />
        {loading &&
            <div
                className='file-preview__preview__loader file-preview__preview__loader--relative'
            >
                <Spinner />
            </div>
        }
    </div>
)

const renderIcon = (ext, is_dir) => {
    return (
        <div className='file-preview__preview__icon-container'>
            <FileIcon
                is_dir={is_dir}
                size='large'
                item={ext}
            />
        </div>
    )
}

export default function FilePreview({ object, url }) {
    let [playing, setPlaying] = useState(false);
    let [mediaLoading, setMediaLoading] = useState(true);
    let [mediaLoadError, setMediaLoadError] = useState(null);
    
    if (!object) return null;

    let ext = object.name && object.name.split('.').pop();

    if (ext) {
        ext = ext.toLowerCase();
    }

    const onClickVideo = function() {
        setPlaying(!playing)
    } 

    const onMediaLoad = () => {
        setMediaLoading(false)

        if (isVideo(ext)) {
            setPlaying(true);
        }
    }

    const onMediaLoadError = (e) => {
        setMediaLoading(false)
        setMediaLoadError(e)
    }

    if (isImage(ext)) {
        return renderImage(url, mediaLoading, mediaLoadError, onMediaLoad, onMediaLoadError);
    }

    if (isVideo(ext)) {
        return renderVideo(url, playing, onClickVideo, mediaLoading, mediaLoadError, onMediaLoad, onMediaLoadError)
    }

    
    return renderIcon(ext, object.is_dir);
}
